import { EventListeners, MinzeElement, Reactive, Attrs } from 'minze'
import { Font } from '../../../constants'
import { Callback } from '../../../modules/callback'
import { Locale } from '../../../modules/locale'

export interface LvcSearchFilterMobile {
  onToggle: string
  title: string
  dataCount: string
  open: boolean
}

Locale.getInstance().registerKeySet('fr', 'lvc-search-filter-mobile', {
  apply: 'Appliquer',
})

Locale.getInstance().registerKeySet('en', 'lvc-search-filter-mobile', {
  apply: 'Apply',
})

export class LvcSearchFilterMobile extends MinzeElement {
  attrs: Attrs = ['title', 'on-toggle', 'data-count', 'open']
  static observedAttributes = ['on-toggle', 'open']

  onCloseButtonClick() {
    this.open = false
    Callback.call(this.onToggle, this.open)
    this.rerender()
  }

  onAttributeChange(name: string, value: any) {
    switch (name) {
      case 'open':
        this.open = !!value
        break
      case 'on-toggle':
        this.onToggle = value ?? ''
        break
    }
  }

  html = () => {
    return /*html*/ `
      <div class="drawer-header ${this.open ? 'open' : ''}" name="toggleDrawer">
        <div class="drawer-title">${this.title}</div>
        <div class="dropdown-button">
          <lvc-chevron-down-icon class="${this.open ? 'up' : 'down'}" width="19.5" height="19.5"></lvc-chevron-down-icon>
        </div>
      </div>
      <div class="drawer-content ${this.open ? 'open' : ''}">
        ${
          this.open
            ? `
          <lvc-box borderBottom="1px solid #1E007D" height="auto" mb="20px" padding="15px 0 0">
            <lvc-box display="flex" alignItems="center" columnGap="6px" mb="18px">
              <lvc-chevron-left-icon></lvc-chevron-left-icon>
              <lvc-text fontSize="18px" font-weight="800">
                ${this.title}
              </lvc-text>
              ${this.dataCount && this.dataCount !== '0' ? `<div id="count">${this.dataCount}</div>` : ''}
            </lvc-box>
          </lvc-box>
        `
            : ''
        }
        <slot name="lvc-drawer-trigger"></slot>
        <slot name="lvc-drawer-content"></slot>
        ${
          this.open
            ? `
          <lvc-box class="apply-filter-button-wrapper" background="white">
            <lvc-button id="apply-filters-button" font-size="12px" height="40px">
              <lvc-box display="flex" justifyContent="center" columnGap="8px" alignItems="center">
                ${Locale.getKey('lvc-search-filter-mobile.apply')}
                <lvc-check-icon data-size="18px"></lvc-check-icon>
              </lvc-box>
            </lvc-button>
          </lvc-box>
        `
            : ''
        }
      </div>
    `
  }

  css = () => {
    return /* css */ `
      :host {
        padding: 0px;
        ${!this.open ? 'border: none;' : ''}
        box-sizing: border-box;
      }
      .drawer-content.open {
        position: fixed;
        top: 0;
        bottom: 73px;
        left: 0;
        right: 0;
        background: white;
        z-index: 1001;
        border-bottom: 1px solid #e5e5e5;
        padding: calc(15px + 2rem) 15px 15px;
        height: calc(100% - 73px - 80px);
        overflow-y: auto;
      }
      .apply-filter-button-wrapper {
        position: fixed;
        bottom: 74px;
        left: 0;
        right: 0;
        height: auto;
        box-shadow: 0px -2px 5px 0px rgba(0, 0, 0, 0.05);
        padding: 20px 15px;
      }
      .drawer-header {
        display: none;
      }

      .dropdown-button{
        display: flex;
        justify-content: flex-end;
      }

      lvc-chevron-down-icon.up {
        transform: rotate(180deg);
        transition: transform 2.2s ease-in-out;
      }
        
      lvc-chevron-down-icon.down {
       transform: rotate(180deg);
        transition: transform 2.2s ease-in-out;
      }

      .drawer-header.open {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        padding: 0px 10px 0px 8px;
      }

      .drawer-title {
        color: var(--brand-minuit, #1E007D);
        font-variant-numeric: lining-nums tabular-nums;
        font-feature-settings: 'clig' off, 'liga' off;

        /* D/boutons/principal */
        font-family: ${Font.family};
        font-size: 14px;
        font-style: normal;
        font-weight: ${Font.weight.medium};
        line-height: 40px;
      }

      .dropdown-button {
        flex: 0 0 auto;
      }
      
      lvc-chevron-left-icon {
        width: 17px;
        height: 17px;
      }


      [name="lvc-drawer-trigger"] {
        ${this.open ? 'display: none;' : ''}
      }

      [name="lvc-drawer-content"] {
        ${!this.open ? 'display: none;' : ''}
        margin: 16px;
      }
      
      #count {
        border: 0.5px solid #1E007D;
        border-radius: 50px;
        width: 32px;
        height: 32px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        bottom: 7px;
      }

      lvc-check-icon {
        height: 18px;
      }
    `
  }

  eventListeners: EventListeners = [
    ['[name="toggleDrawer"]', 'click', this.onCloseButtonClick.bind(this)],
    ['lvc-chevron-left-icon', 'click', this.onCloseButtonClick.bind(this)],
    ['#apply-filters-button', 'click', this.onCloseButtonClick.bind(this)],
  ]
}
